const EDGE_STORE_SETUP_KEY = "edgeStoreSetup";
const SELECTED_STORE_ID_KEY = "selectedStoreId";

export const readEdgeStoreSetup = () => {
  try {
    const raw = localStorage.getItem(EDGE_STORE_SETUP_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
};

export const persistEdgeStoreSetup = (setup) => {
  if (!setup || typeof setup !== "object") return;

  try {
    localStorage.setItem(EDGE_STORE_SETUP_KEY, JSON.stringify(setup));

    if (setup.storeId) {
      localStorage.setItem(SELECTED_STORE_ID_KEY, setup.storeId);
    }
  } catch {
    // ignore localStorage failures
  }
};

export const clearEdgeStoreSetup = () => {
  try {
    localStorage.removeItem(EDGE_STORE_SETUP_KEY);
    localStorage.removeItem(SELECTED_STORE_ID_KEY);
  } catch {
    // ignore localStorage failures
  }
};

export const getDefaultEdgeNodeName = (storeSlug) => {
  if (!storeSlug) return "";

  return `EDGE-${String(storeSlug).trim().toUpperCase().replace(/[^A-Z0-9]+/g, "-")}`;
};
